
import React from 'react';
import Chart from 'react-apexcharts';

interface GraficoAreaProps {
  series: {
    name: string;
    data: number[];
  }[];
  options?: {
    title?: {
      text?: string;
    };
    colors?: string[];
    dataLabels?: {
      enabled?: boolean;
    };
    theme?: {
      mode?: 'dark' | 'light' | undefined;
    };
    xaxis?: { 
      categories?: string[];
    } 
  };
}

const GraficoBarra1: React.FC<GraficoAreaProps> = ({ series, options = {} }) => {
  return (
    <React.Fragment>
      <Chart
        type='bar' 
        height={77}
        series={series}
        options={{
          chart: {
            toolbar: {
              show: false 
            }
          },
          colors: options.colors,
          dataLabels: { 
            enabled: options.dataLabels?.enabled,
           },
          xaxis: {
            categories: options.xaxis?.categories,
            labels: {
              show: false 
            }
          },
          theme: {
            mode: options.theme?.mode,
          },
          plotOptions:{
            bar:{
              horizontal: true
            }
          },       
            
        }}
      />
    </React.Fragment>
  );
};

export default GraficoBarra1;
